import * as React from 'react';
import * as styles from './ResidentialComplexCard.css';
import { IconClose16 } from '@cian/ui-kit';

interface IResidentialComplexCardProps {
  promo?: React.ReactElement | null;
  image: React.ReactElement;
  title?: React.ReactElement | null;
  finishLabel?: React.ReactElement | null;
  minPrice?: React.ReactElement | null;
  subwayInfo?: React.ReactElement | null;
  rooms?: React.ReactElement | null;
  hasClose?: boolean;
  url: string;
}

export function ResidentialComplexCard(props: IResidentialComplexCardProps) {
  const { promo, image, title, finishLabel, minPrice, subwayInfo, rooms, hasClose, url } = props;

  return (
    <article className={styles['card']}>
      {hasClose && (
        <span id="close" className={styles['card__close']}>
          <IconClose16 color="white_100" />
        </span>
      )}

      <a href={url} className={styles['card__wrapper']} target="_blank" rel="noopener noreferrer">
        {promo}
        {image}

        <div className={styles['card-description']}>
          <div className={styles['card-description__item']}>{title}</div>
          {finishLabel && <div className={styles['card-description__item']}>{finishLabel}</div>}
          {minPrice && <div className={styles['card-description__item']}>{minPrice}</div>}
          {subwayInfo && <div className={styles['card-description__item']}>{subwayInfo}</div>}

          {rooms && <div className={styles['rooms']}>{rooms}</div>}
        </div>
      </a>
    </article>
  );
}
